import ModuleMediaPlanning from 'mfMediaPlanning/MediaPlanning';

/**
 * simple re-export of the media planning module, allowing for mocks
 * (the promise based alias 'mfMediaPlanning/*' can't be mocked directly) to be used in tests
 */
export { ModuleMediaPlanning as default };
